module.exports = __webpack_public_path__ + "img/ic_apple-light.b3980ae.svg";